const styles = {
  match: {},
  dialogbody: {
    // padding: '0 30px',
  },

  intro: {
    textAlign: 'center',
    marginTop: '20px',
  },
  introtitle: {
    fontSize: '14px',
    // fontFamily: 'League Gothic',
    fontWeight: '400',
    textTransform: 'uppercase',
  },
  bold: {
    // fontSize: '22px',
    fontWeight: '700',
  },
  introdesc: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
  },
  teamsheader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    marginTop: '20px',
  },
  flag: {
    cursor: 'pointer',
  },
  img: {
    height: '60px',
    width: '60px',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  team: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px 0',
  },
  teamname: {
    fontSize: '26px',
    height: '26px',
    fontWeight: '400',
    // margin: '20px 0 0',
    fontFamily: 'League Gothic',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  chances: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '7px',
  },
  ball_left: {
    height: '14px',
    width: '14px',
    borderRadius: '20px',
    backgroundColor: '#62AD1D',
    marginRight: '7px',
  },
  ball_right: {
    height: '14px',
    width: '14px',
    borderRadius: '20px',
    backgroundColor: '#F9981D',
    marginLeft: '7px',
  },
  gaugecontainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5px 20px 20px',
  },
  teamStats: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    justifyContent: 'center',
    fontSize: '12px',
    marginTop: '30px',
  },
  dialogdesc: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    textAlign: 'center',
    margin: '10px 0 0 0',
  },
  dialogControls: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: '20px 0',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginBottom: '10px',
    color: '#62AD1D',
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
    color: '#F9981D',
  },
  legend: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    margin: '0 10px 10px 0',
    // minWidth: '88px',
    whiteSpace: 'nowrap',
  },
  ball: {
    width: '14px',
    height: '14px',
    border: '1px solid lightgray',
    marginRight: '7px',
    borderRadius: '12px',
  },
  ball1: {
    composes: ['$ball'],
    '&:hover': {
      backgroundColor: '#62AD1D',
    },
  },
  ball2: {
    composes: ['$ball'],
    '&:hover': {
      backgroundColor: '#F9981D',
    },
  },
  footer: {
    borderTop: '1px solid #f2f2f3',
  },
  grow: {
    flexGrow: '0.12',
  },
  spacer: {
    height: '102px',
  },
  victory: {
    marginBottom: '6px',
  },
  recent: {
    margin: '20px 0 10px',
  },
  smalltext: {
    fontSize: '10px',
  },
  separator: {
    height: '15px',
  },
  cardcontainer: {
    margin: '0 auto 120px',
  },
  card: {
    borderRadius: '5px',
    margin: '10px 5px',
    minWidth: '280px',
    minHeight: '284px',
    boxShadow: '0 1px 1px 0 rgba(60,64,67,.08), 0 1px 3px 1px rgba(60, 64, 67, .16)',
    padding: '2px',
    background: '#fff',
  },
  fas: {
    color: '#fff',
  },
  bad: {
    color: 'crimson',
    textDecoration: 'line-through',
    textDecorationStyle: 'double',
  },
};

export default styles;
